import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import Select from "react-select";
import pdficon from "./pdf.png";


function Edit_Logistic_form() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE_URL1 = process.env.REACT_APP_API_BASE_URL1;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();
    const [vehicleModals, setVehicleModals] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [fuelTypes, setFuelTypes] = useState([]);
    const [error, setError] = useState('');
    const [RptMgrName, setRptMgrName] = useState('');
    const [departments, setDepartments] = useState([]);
    const [AdtMgrName, setAdtMgrName] = useState('');
    const [ActMgrName, setActMgrName] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [uploadError, setUploadError] = useState("");
    const [Grade, setGrade] = useState('');
    const [loading, setLoading] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');
    const [fuelImages, setImgRows] = useState('');
    const [fuelContentsImages, setFuelContentsImages] = useState('');
    const [flashAlert, setFlashAlert] = useState(null);
    const [locations, setLocations] = useState([]);
    const [flashAlert1, setFlashAlert1] = useState(null);
    const [flashAlert2, setFlashAlert2] = useState(null);
    const { id } = useParams();
    const Loader = () => (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <p>Loading...</p>
        </div>
    );
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        mode_of_travel: '',
        to_city: '',
        guesthouse: '',
        bank_acnum: '',
        bank_name: '',
        ifsc_code: '',
        total_fuel_amt: '',
        start_time: '',
        total_fuel_qty: '',
        img: []  // To store the image files
    });

    //fetch fuel form data
    const fetchFuelFormData = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getLogisticFormById/${id}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();

            if (result.status && result.data) {
                const fuelForm = result.data;
                const fuelRows = result.fuelFormContents;
                const fuelImages = result.fuelFormImages;
                const fuelContentsImages = result.fuelFormContentsImages;
                setRptMgrName(result.reportManagerName.comp_name || '');
                setAdtMgrName(result.auditManagerName.comp_name || '');
                setActMgrName(result.accountsManagerName.comp_name || '');

                setFormData({
                    id: fuelForm.id || '',
                    emp_code: fuelForm.emp_code || '',
                    comp_name: fuelForm.comp_name || '',
                    mobile: fuelForm.mobile || '',
                    dated: fuelForm.dated || '',
                    bank_acnum: fuelForm.bank_acnum || '',
                    bank_name: fuelForm.bank_name || '',
                    ifsc_code: fuelForm.ifsc_code || '',
                    location_name: fuelForm.location_name || '',
                    grade: fuelForm.grade || '',
                    dept_name: fuelForm.dept_name || '',
                    designation_name: fuelForm.designation_name || '',
                    report_mngr: fuelForm.rpt_mgr || '',
                    isSubmited: fuelForm.isSubmited || 'NO',
                    total_fuel_qty: fuelForm.total_fuel_qty || '0',
                    total_fuel_amt: fuelForm.total_fuel_amt || '0',
                    audit_status: fuelForm.audit_status || '',
                    audit_remarks: fuelForm.audit_remarks || '',
                    audit_approved_km: fuelForm.audit_approved_km || '',
                    audit_mngr: fuelForm.audit_mngr || '',
                    account_mngr: fuelForm.account_mngr || '',
                    rpt_mgr_status: fuelForm.rpt_mgr_status || '',
                    manager_remarks: fuelForm.manager_remarks || '',
                    createdDTM: fuelForm.createdDTM || '',
                    account_status: fuelForm.account_status || '',
                    createdBy: fuelForm.createdBy || '',
                    manager_approved_date: fuelForm.manager_approved_date || '',
                    audit_approved_date: fuelForm.audit_approved_date || '',
                    account_approved_date: fuelForm.account_approved_date || '',
                    is_submitted: fuelForm.is_submitted || '',
                    total_km: fuelForm.total_km || '',
                    created_on: fuelForm.created_on || '',
                    trans_code: fuelForm.trans_code || '',
                });

                if (fuelRows && fuelImages.length > 0) {
                    setTransportRows(fuelImages);
                    console.log("Fuel Rows:", fuelImages);
                }

                if (fuelImages && fuelImages.length > 0) {
                    setImgRows(fuelImages);
                }

                if (fuelContentsImages && fuelContentsImages.length > 0) {
                    setFuelContentsImages(fuelContentsImages);
                }

            } else {
                setError(result.message || 'Failed to fetch form data');
            }
        } catch (error) {
            console.error('Fetch error:', error);
           // setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchFuelFormData();
    }, [id]);



    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitAllowed, setIsSubmitAllowed] = useState(true);
    const [transportRows, setTransportRows] = useState([{
        id: 1,
        dated: '',
        vehicle_number: '',
        description: '',
        purpose: '',
        start_km: '',
        vehicle_type: '',
        fuel_type: '',
        fuel_unit: '',
        fuel_rate: '',
        fuel_quantity: '',
        fuel_amount: '', receipt: []
    }]);

    useAuth();  // Custom hook for authentication

    const handleBackClick = () => {
        navigate("/manage_logistic_forms");
    };

    const handleAddTransportRow = () => {
        setTransportRows([
            ...transportRows,
            {
                id: transportRows.length + 1, dated: '', vehicle_number: '', description: '',
                vehicle_type: '', fuel_type: '', purpose: '', start_km: '',
                fuel_unit: '', fuel_rate: '', fuel_quantity: '', fuel_amount: '', receipt: []
            }
        ]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };




    // fetch vehicle types
    const fetchVehicleTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
           // setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle numbers
    const fetchVehicleNumbers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleNumbers`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleNumbers(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
          //  setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };




    useEffect(() => {
        fetchVehicleTypes();

        fetchVehicleNumbers();


    }, [navigate]);



    const handleTransportChange = (index, e) => {
        const { name, value, type, files, id } = e.target;
        const newTransportRows = [...transportRows];
        newTransportRows[index] = { ...newTransportRows[index], [name]: value };


        // Update  
        if (name === 'vehicle_number') {
            // newTransportRows[index].fuel_amount = newTransportRows[index].fuel_rate * newTransportRows[index].fuel_quantity;
            const vehicle = vehicleNumbers.find(vehicle => vehicle.vehicle_number === value);
            if (vehicle) {

                newTransportRows[index].vehicle_type = vehicle.vehicle_type;
                newTransportRows[index].description = vehicle.description;
                newTransportRows[index].fuel_type = vehicle.fuel_type;
                newTransportRows[index].fuel_unit = vehicle.fuel_unit;
            } else {

                newTransportRows[index].vehicle_type = '';
                newTransportRows[index].description = '';
                newTransportRows[index].fuel_type = '';
                newTransportRows[index].fuel_unit = '';
            }
        }

        if (name === "start_km" || name === "end_km") {

            const startKm = parseFloat(newTransportRows[index].start_km) || 0;
            const endKm = parseFloat(newTransportRows[index].end_km) || 0;
            console.log("checker", Math.max(0, endKm - startKm));
            // newTransportRows[index].total_kms = Math.max(0, endKm - startKm); // Ensure no negative values
            newTransportRows[index].total_km = Math.max(0, endKm - startKm);

        }

        // Update fuel amount when rate or quantity changes (if both are present and quantity is not 0)
        if (name === 'fuel_rate' || name === 'fuel_quantity') {
            // Calculate the fuel amount based on rate and quantity
            const rate = parseFloat(newTransportRows[index].fuel_rate) || 0;
            const quantity = parseFloat(newTransportRows[index].fuel_quantity) || 0;
            newTransportRows[index].fuel_amount = rate * quantity;
            //execute after completing above


        }

        // Update department name if changed
        if (name === "department") {
            newTransportRows[index].department = value;
        }

        if (parseFloat(newTransportRows[index].fuel_quantity) === 0) {
            // If quantity is 0, fuel_amount can be manually entered
            if (name === 'fuel_amount') {
                newTransportRows[index].fuel_amount = parseFloat(value) || 0;
            } else {
                newTransportRows[index].fuel_amount = '';
            }
        } else {
            // If quantity is not 0, calculate fuel_amount automatically
            const rate = parseFloat(newTransportRows[index].fuel_rate) || 0;
            const quantity = parseFloat(newTransportRows[index].fuel_quantity) || 0;
            newTransportRows[index].fuel_amount = rate * quantity;
        }


        const MAX_SIZE = 1 * 1024 * 1024;
        const MAX_WIDTH = 800;
        const MAX_HEIGHT = 800;

        // If the input type is 'file' and there are selected files
        if (type === 'file' && files.length > 0) {
            const file = files[0];

            if (file.size > MAX_SIZE) {
                resizeImage(file, MAX_WIDTH, MAX_HEIGHT, (resizedFile) => {
                    newTransportRows[index] = { ...newTransportRows[index], [name]: resizedFile };
                    setTransportRows(newTransportRows);
                });
            } else {
                newTransportRows[index] = { ...newTransportRows[index], [name]: file };
                setTransportRows(newTransportRows);
            }
        } else {
            // For other input types (non-file), just update the value normally
            newTransportRows[index] = { ...newTransportRows[index], [name]: value };
        }

        // Update the transport rows state
        setTransportRows(newTransportRows);


    };





    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const MAX_SIZE = 1 * 1024 * 1024;
        const MAX_WIDTH = 800;
        const MAX_HEIGHT = 800;

        const validFiles = [];

        files.forEach(file => {
            if (file.size > MAX_SIZE) {
                resizeImage(file, MAX_WIDTH, MAX_HEIGHT, (resizedFile) => {
                    validFiles.push(resizedFile);
                    setFormData(prevData => ({
                        ...prevData,
                        img: validFiles
                    }));
                });
            } else {
                validFiles.push(file);
            }
        });

        setFormData(prevData => ({
            ...prevData,
            img: validFiles
        }));
    };

    const resizeImage = (file, maxWidth, maxHeight, callback) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                let width = img.width;
                let height = img.height;

                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) => {
                    const resizedFile = new File([blob], file.name, {
                        type: file.type,
                        lastModified: Date.now(),
                    });
                    callback(resizedFile);
                }, file.type);
            };
        };
    };



    const handleRemoveTransportRow = (index) => {
        if (transportRows.length > 1) {
            setTransportRows(transportRows.filter((_, i) => i !== index));
        }
    };





    // Calculate the total amount
    const calculateTotal = () => {
        // Calculate the total amount, make total of all total_fuel_amt rows
        const total_amt = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_amount)), 0);
        //update formData
        setFormData(prevState => ({
            ...prevState,
            total_fuel_amt: total_amt
        }));

    };


    // Calculate the total quantity
    const calculateTotalQuantity = () => {


        const total_qty = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_quantity) || 0), 0);
        //update formData
        setFormData(prevState => ({
            ...prevState,
            total_fuel_qty: total_qty
        }));


    };

    useEffect(() => {
        calculateTotal();
        calculateTotalQuantity();
    }, [transportRows]);


    useEffect(() => {
        const fetchDepartments = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}departments`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Departments data:", result); // Debugging log

                if (Array.isArray(result)) {
                    setDepartments(result);
                } else {
                    throw new Error("Invalid response format");
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to load departments.');
            } finally {
                setLoading(false);
            }
        };

        fetchDepartments();
    }, []);

    useEffect(() => {
            const fetchLocations = async () => {
                setLoading(true);
                try {
                    const token = localStorage.getItem('authToken');
                    const response = await fetch(`${API_BASE_URL}locations`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });
    
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
    
                    const result = await response.json();
                    console.log("Locations data:", result); // Debugging log
    
                    if (Array.isArray(result)) {
                        setLocations(result);
                    } else {
                        throw new Error("Invalid response format");
                    }
                } catch (error) {
                    console.error('Fetch error:', error);
                    //setError('Failed to load locations.');
                } finally {
                    setLoading(false);
                }
            };
    
            fetchLocations();
        }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        for (let row of transportRows) {
            const startKm = parseFloat(row.start_km);
            const endKm = parseFloat(row.end_km);

            if (isNaN(startKm) || isNaN(endKm)) {
                toast.error("Please enter both Start and End KMs.");
                return; // Stop submission
            }

            if (endKm <= startKm) {
                toast.error("End KMs must be greater than Start KMs.");
                return; // Stop submission
            }
        }

        if (!isSubmitAllowed) {
            toast.error("Please fix the file size errors before submitting.");
            return;
        }
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const formattedFormData = { ...formData };

            // Convert image files to Base64
            if (formattedFormData.img && Array.isArray(formattedFormData.img)) {
                const imgBase64Promises = formattedFormData.img.map(async (file) => {
                    if (file instanceof File) {
                        return await convertToBase64(file);
                    }
                    return file;
                });
                formattedFormData.img = await Promise.all(imgBase64Promises);
            }

            // Convert transportRows receipts to Base64
            const formattedTransportRows = await Promise.all(
                transportRows.map(async (row) => {
                    const newRow = { ...row };
                    if (newRow.receipt instanceof File) {
                        newRow.receipt = await convertToBase64(newRow.receipt);
                    }
                    return newRow;
                })
            );

            const sum_km = transportRows.reduce((sum, row) => sum + ((row.end_km - row.start_km) || 0), 0);
            const start_km = transportRows.reduce((sum, row) => sum + Number((row.start_km) || 0), 0);
            const end_km = transportRows.reduce((sum, row) => sum + Number((row.end_km) || 0), 0);
            const sum_repairs = transportRows.reduce((sum, row) => sum + (row.repairs || 0), 0);
            const sum_bill = transportRows.reduce((sum, row) => sum + (row.bill_amt || 0), 0)

            // Prepare the final JSON payload
            const requestBody = {
                ...formattedFormData,
                transportRows: formattedTransportRows,
                sum_km,
                start_km,
                end_km,
                sum_repairs,
                sum_bill
            };

            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}updateLogisticForm/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            const result = await response.json();
            if (response.ok && result.status === 'success') {
                toast.success('Fuel Form submitted successfully!');
                fetchFuelFormData();
                setTimeout(() => {
                    navigate('/edit_logistic_form/' + id);
                }, 2000);
            } else {
                toast.error(result.message || 'An error occurred while submitting the form.');
            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error('Failed to submit form');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Helper function to convert File to Base64
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };




    const sendForApproval = async () => {
        if (!window.confirm("Are you sure you want to submit this form for approval? Once submitted, you cannot edit the form.")) {
            return; // Exit if user cancels
        }

        try {
            const response = await fetch(`${API_BASE_URL}submitLogisticForm/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    formId: formData?.id, // Example form ID, replace with actual data
                    isSubmited: "YES"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            alert("Form submitted successfully for approval!");
            window.location.reload();
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("An error occurred while submitting the form.");
        }
    };

    const hasAmbulance = transportRows.some(row => row.purpose === "patient");
    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Edit Logistic Form ({formData?.trans_code})</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Fuel Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <div className="box-body">
                                                    <div className="row">

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="emp_code"
                                                                    id="name"
                                                                    value={formData?.emp_code || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee No/Consultant"
                                                                    readOnly
                                                                />

                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="comp_name"
                                                                    id="name"
                                                                    value={formData.comp_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Name"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee Band</label>
                                                                <input
                                                                    type="text"
                                                                    name="grade"
                                                                    id="name"
                                                                    value={formData.grade}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Department</label>
                                                                <input
                                                                    type="text"
                                                                    name="dept_name"
                                                                    id="name"
                                                                    value={formData.dept_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Designation </label>
                                                                <input
                                                                    type="text"
                                                                    name="designation_name"
                                                                    id="name"
                                                                    value={formData.designation_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Mobile No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="mobile"
                                                                    id="name"
                                                                    value={formData.mobile}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_name">Bank Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    id="bank_name"
                                                                    value={formData.bank_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_acnum">Bank Ac.No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_acnum"
                                                                    id="bank_acnum"
                                                                    value={formData.bank_acnum}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="ifsc_code">IFSC Code
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    id="ifsc_code"
                                                                    value={formData.ifsc_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Reporting Manager
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.report_mngr}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Location
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.location_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-warning" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Details of Logistic Form
                                                    </span>
                                                </center>

                                                <div className="transport-table-container mb-3 text-right">
                                                    <button type="button" onClick={handleAddTransportRow} className="btn btn-sm btn-primary">+</button>

                                                    {/* Responsive Table Wrapper */}
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <td colSpan="12"></td>
                                                                </tr>
                                                                <tr className="header-row text-center">
                                                                    <th>Date<span className="text-danger">*</span></th>

                                                                    <th>Vehicle Number<span className="text-danger">*</span></th>
                                                                    <th>Type<span className="text-danger">*</span></th>
                                                                    <th>Description</th>
                                                                    <th>Branch</th>
                                                                    <th>Purpose</th>
                                                                    <th>Start KMs</th>
                                                                    <th>Start Time</th>
                                                                    <th>End KMs</th>
                                                                    <th>End Time</th>
                                                                    <th>Total KMs</th>
                                                                    <th>Center-From</th>
                                                                    <th>Center-To</th>

                                                                    <th>Travel</th>
                                                                    <th>Department</th>
                                                                    <th>Requested By</th>
                                                                    {/* <th>Repairs</th> */}
                                                                    <th>Remarks</th>
                                                                    {hasAmbulance && (
                                                                        <>
                                                                            <th>Bill No</th>
                                                                            <th>Bill Amt</th>
                                                                            <th>Bills Images</th>
                                                                        </>
                                                                    )}
                                                                   
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {transportRows.map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input type="date" name="dated" value={row.dated} onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font" max={new Date().toISOString().split("T")[0]} required={index === 0} />
                                                                        </td>

                                                                        <td style={{ minWidth: '6rem' }}>

                                                                            <input placeholder='Number' list="vm" className='form-control input-font'
                                                                                name='vehicle_number' id='vehicle_number'
                                                                                value={row.vehicle_number}
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                            <datalist id="vm">
                                                                                {vehicleNumbers.map((vehicleNumber) => (
                                                                                    <option key={vehicleNumber.id} value={vehicleNumber.vehicle_number}>
                                                                                        {vehicleNumber.vehicle_number}
                                                                                    </option>
                                                                                ))}
                                                                            </datalist>
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="text" readOnly value={row.vehicle_type} name="vehicle_type" />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <select
                                                                                name="description"
                                                                                value={row.description || ''}
                                                                                className="form-control input-font"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                disabled
                                                                            >
                                                                                <option value="">Select Booked By</option>
                                                                                <option value="Four Wheeler">Four Wheeler</option>
                                                                                <option value="Three Wheeler">Three Wheeler</option>
                                                                                <option value="Two Wheeler">Two Wheeler</option>
                                                                            </select>
                                                                        </td>
                                                                        <td style={{ minWidth: '15rem' }}>
                                                                                <Select
                                                                                    name="center"
                                                                                    value={locations.find(location => location.location_name === row.center)
                                                                                        ? { value: row.center, label: row.center }
                                                                                        : null}
                                                                                    onChange={(selectedOption) =>
                                                                                        handleTransportChange(index, { target: { name: "center", value: selectedOption?.value } })
                                                                                    }
                                                                                    options={locations.map(location => ({ value: location.location_name, label: location.location_name }))}
                                                                                    className="form-control input-font"
                                                                                    isSearchable={true}
                                                                                    placeholder="Select Location"
                                                                                    menuPortalTarget={document.body} // Prevents dropdown cutoff
                                                                                    styles={{
                                                                                        control: (provided) => ({
                                                                                            ...provided,
                                                                                            minHeight: '20px', // Reduced height
                                                                                            height: '20px', // Set exact height
                                                                                            borderRadius: '4px',
                                                                                            borderColor: '#ced4da',
                                                                                            fontSize: '13px', // Reduce font size slightly
                                                                                            padding: '0px 5px', // Reduce padding
                                                                                        }),
                                                                                        dropdownIndicator: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '2px', // Reduce dropdown arrow padding
                                                                                        }),
                                                                                        clearIndicator: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '2px', // Reduce clear button padding
                                                                                        }),
                                                                                        menu: (provided) => ({
                                                                                            ...provided,
                                                                                            zIndex: 9999, // Ensures dropdown is visible
                                                                                        }),
                                                                                        input: (provided) => ({
                                                                                            ...provided,
                                                                                            fontSize: '13px', // Reduce input font size
                                                                                            padding: '0px', // Remove extra padding inside input
                                                                                        }),
                                                                                        valueContainer: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '0px 6px', // Reduce spacing around selected value
                                                                                        }),
                                                                                    }}
                                                                                />
                                                                            </td> 
                                                                        <td style={{ minWidth: '12rem' }}>

                                                                            <select
                                                                                className="form-control input-font"
                                                                                value={row.purpose}
                                                                                name="purpose"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                            >
                                                                                <option value="">Select Purpose</option>
                                                                                <option value="office_purpose">Office Purpose</option>
                                                                                <option value="branch_visit">Branch Visit</option>
                                                                                <option value="patient">Patient</option>
                                                                                <option value="other_purpose">Other Purpose</option>
                                                                            </select>

                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="number" value={row.start_km} name="start_km"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="time" value={row.start_time} name="start_time"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="number" value={row.end_km} name="end_km"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="time" value={row.end_time} name="end_time"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                className="form-control input-font"
                                                                                type="number"
                                                                                value={row.end_km - row.start_km || 0} // Automatically calculates total_kms
                                                                                name="total_km"
                                                                                readOnly // Makes it non-editable
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="text" value={row.center_from} name="center_from"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="text" value={row.center_to} name="center_to"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td>

                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <select
                                                                                className="form-control input-font"
                                                                                value={row.travel}
                                                                                name="travel"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                            >
                                                                                <option value="">Select Station</option>
                                                                                <option value="Ex_Station">Ex Station</option>
                                                                                <option value="Out_Station">Out Station</option>
                                                                                <option value="Local">Local</option>
                                                                            </select>
                                                                        </td>
                                                                        <td style={{ minWidth: '15rem' }}>
                                                                            <Select
                                                                                name="department"
                                                                                value={departments.find(dept => dept.dept_name === row.department)
                                                                                    ? { value: row.department, label: row.department }
                                                                                    : null}
                                                                                onChange={(selectedOption) =>
                                                                                    handleTransportChange(index, { target: { name: "department", value: selectedOption?.value } })
                                                                                }
                                                                                options={departments.map(dept => ({ value: dept.dept_name, label: dept.dept_name }))}
                                                                                className="form-control input-font"
                                                                                isSearchable={true}
                                                                                placeholder="Select Department"
                                                                                menuPortalTarget={document.body} // Prevents dropdown cutoff
                                                                                styles={{
                                                                                    control: (provided) => ({
                                                                                        ...provided,
                                                                                        minHeight: '20px', // Reduced height
                                                                                        height: '20px', // Set exact height
                                                                                        borderRadius: '4px',
                                                                                        borderColor: '#ced4da',
                                                                                        fontSize: '13px', // Reduce font size slightly
                                                                                        padding: '0px 5px', // Reduce padding
                                                                                    }),
                                                                                    dropdownIndicator: (provided) => ({
                                                                                        ...provided,
                                                                                        padding: '2px', // Reduce dropdown arrow padding
                                                                                    }),
                                                                                    clearIndicator: (provided) => ({
                                                                                        ...provided,
                                                                                        padding: '2px', // Reduce clear button padding
                                                                                    }),
                                                                                    menu: (provided) => ({
                                                                                        ...provided,
                                                                                        zIndex: 9999, // Ensures dropdown is visible
                                                                                    }),
                                                                                    input: (provided) => ({
                                                                                        ...provided,
                                                                                        fontSize: '13px', // Reduce input font size
                                                                                        padding: '0px', // Remove extra padding inside input
                                                                                    }),
                                                                                    valueContainer: (provided) => ({
                                                                                        ...provided,
                                                                                        padding: '0px 6px', // Reduce spacing around selected value
                                                                                    }),
                                                                                }}
                                                                            />
                                                                        </td>


                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="text" value={row.requested_by} name="requested_by"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="text" value={row.remarks} name="remarks"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td>
                                                                        {/* <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font" type="text" value={row.remarks} name="remarks"
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                        </td> */}
                                                                        {row.purpose === "patient" && (
                                                                            <>
                                                                                <td style={{ minWidth: '6rem' }}>
                                                                                    <input
                                                                                        className="form-control input-font"
                                                                                        type="text"
                                                                                        value={row.bill_no}
                                                                                        name="bill_no"
                                                                                        onChange={(e) => handleTransportChange(index, e)}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ minWidth: '6rem' }}>
                                                                                    <input
                                                                                        className="form-control input-font"
                                                                                        type="text"
                                                                                        value={row.bill_amt}
                                                                                        name="bill_amt"
                                                                                        onChange={(e) => handleTransportChange(index, e)}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ minWidth: '12rem' }}>
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                {/* File Input */}
                                                                                <input
                                                                                    type="file"
                                                                                    name="receipt"
                                                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                                                    onChange={(e) => handleTransportChange(index, e)}
                                                                                    className="form-control input-font"
                                                                                    style={{ width: '180px' }} // Adjust width as needed
                                                                                />

                                                                                {/* File Preview */}
                                                                                {row.receipt && typeof row.receipt === 'string' && (
                                                                                    <a
                                                                                        href={`${API_BASE_URL1}assets/uploads/${row.receipt}`}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="position-relative"
                                                                                    >
                                                                                        {row.receipt.toLowerCase().endsWith('.pdf') ? (
                                                                                            // Show PDF icon if the file is a PDF
                                                                                            <img
                                                                                                src={pdficon} // Replace with your PDF icon path
                                                                                                alt="Receipt PDF"
                                                                                                style={{ width: '50px', height: '50px', borderRadius: '4px' }} // Add rounded corners
                                                                                            />
                                                                                        ) : (
                                                                                            // Show image if it's not a PDF
                                                                                            <img
                                                                                                src={`${API_BASE_URL1}assets/uploads/${row.receipt}`} // Actual image file path
                                                                                                alt="receipt"
                                                                                                style={{
                                                                                                    width: '50px',
                                                                                                    height: '50px',
                                                                                                    borderRadius: '4px',
                                                                                                    objectFit: 'cover',
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </a>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                            </>
                                                                        )}
                                                                        


                                                                        <td>
                                                                            <button type="button" onClick={() => handleRemoveTransportRow(index)}
                                                                                className="btn btn-sm btn-danger">×</button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                    <tr>
                                                                        {/* Sum of Total KMs under Total KMs column */}
                                                                       
                                                                        <td colSpan="6"></td> {/* Empty columns before Total KMs */}
                                                                        <td><b>{transportRows.reduce((sum, row) => sum + Number(row.start_km || 0), 0)}</b></td>

                                                                        <td colSpan="0"></td>
                                                                        
                                                                         {/* Empty columns before Total KMs */}
                                                                        <td><b>{transportRows.reduce((sum, row) => sum + Number(row.end_km || 0), 0)}</b></td>
                                                                        <td><b>Sum of Total KMs:</b></td>
                                                                        <td><b>{transportRows.reduce((sum, row) => sum + (row.end_km - row.start_km || 0), 0)}</b></td>

                                                                        {/* Empty columns until Repairs */}
                                                                        <td colSpan="5"></td>

                                                                        {/* Total Repairs Cost under Repairs column */}
                                                                        {/* <td><b>Total Repairs Cost:</b></td>
                                                                        <td><b>{transportRows.reduce((sum, row) => sum + (parseFloat(row.repairs) || 0), 0)}</b></td> */}

                                                                        {/* Empty columns until Bill Amount */}
                                                                        <td colSpan="1"></td>

                                                                        {/* Total Bill Amount under Bill Amt column */}
                                                                        {hasAmbulance && (
                                                                            <>
                                                                                <td><b>Total Bill Amount:</b></td>
                                                                                <td><b>{transportRows.reduce((sum, row) => sum + (parseFloat(row.bill_amt) || 0), 0)}</b></td>
                                                                            </>
                                                                        )}

                                                                        {/* Empty remaining columns */}
                                                                        <td colSpan="1"></td>
                                                                    </tr>
                                                                </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-primary" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Additional Documents
                                                    </span>
                                                </center>
                                                <div className="document-table-container" style={{ marginBottom: '20px', textAlign: 'right' }}>
                                                    <table className="document-table" style={{ marginTop: '10px' }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ textAlign: 'center' }}>Click to Preview</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* Loop through fuelImages and display each document's image */}
                                                            {fuelContentsImages.length > 0 ? (
                                                                <tr>
                                                                    <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                            {fuelContentsImages.map((document) => {
                                                                                // Construct the image URL outside the JSX expression
                                                                                const imageUrl = `${API_BASE_URL1}assets/uploads/${document.img}`;

                                                                                return (
                                                                                    <div key={document.id} style={{ margin: '10px' }}>
                                                                                        <a href={imageUrl} target="_blank" rel="noopener noreferrer" className="position-relative">
                                                                                            {document.img && typeof document.img === 'string' && document.img.toLowerCase().endsWith('.pdf') ? (
                                                                                                // If the document is a PDF, show the PDF icon
                                                                                                <img
                                                                                                    src={pdficon} // Replace with the actual path to your PDF icon
                                                                                                    alt={`PDF Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '100px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            ) : document.img ? (
                                                                                                // Otherwise, show the image
                                                                                                <img
                                                                                                    src={imageUrl}
                                                                                                    alt={`Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '79px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                <span>No Image</span> // Fallback if document.img is missing
                                                                                            )}

                                                                                        </a>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                        {error ? error : 'No documents available.'}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </fieldset>


                                            {/* Uplosad Images Section */}
                                            <section className="col-lg-12">
                                                {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}

                                                <label className="font-weight-bold">Upload Multiple Images:</label>
                                                <input
                                                    type="file"
                                                    name="img"
                                                    multiple
                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                    onChange={handleFileChange}
                                                    className="form-control mb-3"
                                                />


                                                {/* Reporting Manager Section */}
                                                <div className="row mt-3">
                                                    {/* Reporting Manager Status */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="rpt_mgr_status" className="form-label" style={{ fontSize: '12px' }}>
                                                                Reporting Manager Status <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <select
                                                                name="rpt_mgr_status"
                                                                id="rpt_mgr_status"
                                                                value={formData.rpt_mgr_status || ''}
                                                                onChange={handleChange}
                                                                className="form-control custom-select"
                                                                required
                                                                disabled
                                                            >
                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                    {/* Reporting Manager Remarks */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="remarks" className="form-label" style={{ fontSize: '12px' }}>
                                                                Reporting Manager Remarks <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <textarea
                                                                name="manager_remarks"
                                                                id="remarks"
                                                                value={formData.manager_remarks || ''}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                                required
                                                                disabled
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div class="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="audit_status">Audit Status
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <select
                                                                name="audit_status"
                                                                id="audit_status"
                                                                value={formData.audit_status}
                                                                onChange={handleChange}
                                                                disabled
                                                                className="form-control input-font custom-select"

                                                            >

                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>

                                                        </div>
                                                    </div><div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">
                                                                Audit Approved Amount
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <input
                                                                type="text"  // Keep the type as text
                                                                name="audit_approved_km"
                                                                id="name"
                                                                value={formData.audit_approved_km !== '' ? Math.floor(formData.audit_approved_km) : ''}
                                                                onChange={handleChange}
                                                                onInput={(e) => {
                                                                    // Allow only numeric input (no decimal, no special characters)
                                                                    const inputValue = e.target.value;
                                                                    if (/[^0-9]/.test(inputValue)) {
                                                                        // If non-numeric character is found, remove it
                                                                        e.target.value = inputValue.replace(/[^0-9]/g, '');
                                                                    }
                                                                }}
                                                                className="form-control input-font"
                                                                required
                                                                disabled
                                                            />
                                                        </div>

                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="audit_remarks">Audit Remarks
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>

                                                            <textarea
                                                                id="audit_remarks"
                                                                name="audit_remarks"
                                                                value={formData.audit_remarks}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                                required
                                                                rows='1'
                                                                disabled
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div> */}

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center">
                                                    {formData?.is_submitted === 'NO' && (<button type="submit" className="btn btn-warning">
                                                        {isSubmitting ? 'Saving Changes...' : 'Save As Drafts'}
                                                    </button>)}
                                                    <button type="button" className="btn btn-secondary ml-3" onClick={handleBackClick}>
                                                        Cancel
                                                    </button>

                                                </div>
                                            </section>

                                        </form>
                                        <div className="d-flex justify-content-center mt-3">
                                            {formData?.is_submitted === 'NO' && (<button onClick={sendForApproval} className='btn btn-success ml-3'>Send for Approval</button>)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 row" style={{ width: '100%' }}>
                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                        <b>Prepared by </b>
                                        <p> {formData.emp_code} ({formData.comp_name})<br /> Date
                                            : {formData.created_on}
                                        </p>
                                    </div>
                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                        {formData.rpt_mgr_status === 'Approved' && (
                                            <>
                                                <b> Approved by</b>
                                                <p> {formData.report_mngr} ({RptMgrName})<br /> Date
                                                    : {formData.manager_approved_date}
                                                </p>
                                            </>
                                        )}
                                    </div>
                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                        {formData.audit_status === 'Approved' && (
                                            <>
                                                <b> Verified by Audit Team</b>
                                                <p>                         <span>
                                                    {formData.audit_mngr} ({AdtMgrName})<br /> Date
                                                    : {formData.audit_approved_date}
                                                </span>
                                                </p>
                                            </>
                                        )}
                                    </div>
                                    {/* <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                        {formData.account_status === 'Approved' && (
                                            <>
                                                <b> Verified by Finance Team</b>
                                                <p>                         <span>
                                                    {formData.account_mngr} ({ActMgrName})<br /> Date
                                                    : {formData.account_approved_date}
                                                </span>
                                                </p>
                                            </>
                                        )}
                                    </div> */}
                                </div>
                            </section>
                        </>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    )
}

export default Edit_Logistic_form